import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, withMemo as _withMemo, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "text-raleway-22 t-blue mr-3 mb-1 title-section bank-details" }
const _hoisted_2 = { class: "wrapper-details bank-details" }
const _hoisted_3 = { class: "bank-details-wrapper-top d-flex" }
const _hoisted_4 = { class: "d-flex a-i-center j-content-s-be" }
const _hoisted_5 = { class: "uppercase text-raleway-13" }
const _hoisted_6 = { class: "uppercase text-motserrat-8-bold text-end" }
const _hoisted_7 = { class: "d-flex a-i-center j-content-s-be" }
const _hoisted_8 = { class: "uppercase text-raleway-13" }
const _hoisted_9 = { class: "uppercase text-motserrat-8-bold text-end" }
const _hoisted_10 = { class: "bank-details-wrapper-bottom d-flex" }
const _hoisted_11 = { class: "d-flex a-i-center j-content-s-be" }
const _hoisted_12 = { class: "uppercase text-raleway-13" }
const _hoisted_13 = { class: "uppercase text-motserrat-8-bold text-end" }
const _hoisted_14 = { class: "account-select-double" }
const _hoisted_15 = { class: "d-flex a-i-center j-content-s-be" }
const _hoisted_16 = { class: "uppercase text-raleway-13" }
const _hoisted_17 = { class: "uppercase text-motserrat-8-bold text-end" }
const _hoisted_18 = { class: "mt-2 mb-2" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }

import { BankDataComponentValidation } from "@/utils/validation/accauntDetailsValidation/bankDetailComponent";
import SelectSearchComponent from "@/components/select/SelectSearchComponent.vue";
import { BankDataComponent } from "@/store/modules/accountDetails/type";
import { getSearchDebounce } from "../debounce/getSearchDebounce";
import { GeoPlaceData } from "@/store/modules/GeoPlace/type";
import { debounce } from "@/utils/debounce/debounce";
import { Bank } from "@/store/modules/Bank/type";
import { Field, useForm } from "vee-validate";
import { computed, inject, ref, watch } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'bankDetailsComponent',
  setup(__props) {

const store = useStore();
const bankData = ref(computed<Bank[]>(() => store.getters.getBankDataByUserId));
const bankOptions = ref(
  computed<{ data: GeoPlaceData[]; loading: boolean }>(
    () => store.getters.getBankSearchCity
  )
);
const searchCityBank = debounce(
  getSearchDebounce,
  400,
  (target: HTMLInputElement) =>
    store.dispatch("getSearchCityBank", target.value)
);

const errorValues = ref();
const allErrors = ref();

watch(
  () => store.getters?.getGlobalErrorsBankDataComponent || [],
  (value) => {
    allErrors.value = value;
    errorValues.value = allErrors.value.map((value: any) =>
      Array.isArray(Object.keys(value))
        ? Object.keys(value)[0]
        : Object.keys(value)
    );
  },
  {
    deep: true,
  }
);

const uiLang = ref(computed<string>(() => store.getters.getUserUiLang));

const initialValues = ref<BankDataComponent>(
  store.getters.getBankDataComponentValuesAccountDetails
);

const { meta, errors, values, resetForm, validate } =
  useForm<BankDataComponent>({
    initialValues,
    validationSchema: BankDataComponentValidation,
  });

const addForm = inject<any>("ADD_FORM");

addForm({
  position: 3,
  initialValues,
  meta,
  errors,
  values,
  validate,
  resetForm,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    class: "wrapper-details-data",
    onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_unref(validate)()), ["prevent"]))
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(_ctx.$tc("bank_details")), 1),
    _createElementVNode("article", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _withMemo([
            uiLang.value,
            bankData.value[0]?.bank_name,
            _unref(errors)?.bank_name,
            _unref(values)?.bank_name,
          ], () => (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["mr-2 input-slim", { 'error-input mini': !!_unref(errors)?.bank_name }])
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$tc("bank name")), 1),
            _createElementVNode("p", _hoisted_6, _toDisplayString(_ctx.$tc("(optional)")), 1)
          ]),
          _createVNode(_unref(Field), {
            tabindex: 9,
            maxlength: "30",
            type: "text",
            name: "bank_name",
            class: "input input-mini",
            value: _unref(values)?.bank_name,
            placeholder: _ctx.$tc('Bank name')
          }, null, 8, ["value", "placeholder"])
        ], 2)), _cache, 0),
        _withMemo([
            uiLang.value,
            (bankData.value || [])[0]?.correspond_account,
            _unref(values)?.correspond_account,
            _unref(errors)?.correspond_account,
          ], () => (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["input-slim", { 'error-input mini': !!_unref(errors)?.correspond_account }])
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.$tc("bank corr address")), 1),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$tc("(optional)")), 1)
          ]),
          _createVNode(_unref(Field), {
            tabindex: 10,
            maxlength: "30",
            type: "text",
            name: "correspond_account",
            value: _unref(values)?.correspond_account,
            class: "input input-mini",
            placeholder: _ctx.$tc('Bank corr address')
          }, null, 8, ["value", "placeholder"])
        ], 2)), _cache, 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _withMemo([
            uiLang.value,
            bankOptions.value?.data,
            _unref(errors)?.bank_city,
            initialValues.value.bank_city,
          ], () => (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["mr-2 input-slim", { 'error-input mini': !!_unref(errors)?.bank_city }])
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.$tc("city of bank")), 1),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_ctx.$tc("(optional)")), 1)
          ]),
          _createElementVNode("div", _hoisted_14, [
            _createVNode(SelectSearchComponent, {
              tabindex: 10,
              "title-select": false,
              drop: true,
              store: 'updateCitySelect',
              title: initialValues.value.bank_city || '',
              default: initialValues.value.bank_city,
              options: bankOptions.value?.data,
              disabled: false,
              name: 'bank_city',
              onInput: _unref(searchCityBank),
              maxElement: 5,
              solid: true,
              loading: bankOptions.value.loading,
              "error-min": true
            }, null, 8, ["title", "default", "options", "onInput", "loading"])
          ])
        ], 2)), _cache, 2),
        _withMemo([
            uiLang.value,
            (bankData.value || [])[0]?.number,
            _unref(values)?.number,
            _unref(errors)?.number,
          ], () => (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["mr-2 input-slim", { 'error-input mini': !!_unref(errors)?.number }])
        }, [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.$tc("account number")), 1),
            _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.$tc("(optional)")), 1)
          ]),
          _createVNode(_unref(Field), {
            tabindex: 11,
            maxlength: "30",
            type: "text",
            name: "number",
            class: "input input-mini",
            value: _unref(values)?.number,
            placeholder: _ctx.$tc('Account number')
          }, null, 8, ["value", "placeholder"])
        ], 2)), _cache, 3)
      ])
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_18, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allErrors.value, (error) => {
        return (_openBlock(), _createElementBlock("p", {
          class: "uppercase text-raleway-13 t-danger text-center",
          key: error
        }, [
          (typeof error === 'object')
            ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(Object.keys(error) + ": " + Object.values(error)), 1))
            : (_openBlock(), _createElementBlock("span", _hoisted_20, _toDisplayString(error), 1))
        ]))
      }), 128))
    ], 512), [
      [_vShow, allErrors.value]
    ])
  ], 32))
}
}

})